import type MeService from '@/core/shared/me/me.service';

export interface SwitchableEmployer {
  id: number;
  name: string;
}

type EmployerUserMaps = NonNullable<MeService['userProfile']>['employerUserMaps'];

// Orgs a user can switch between (employer maps with a named employer). One source
// so the account-menu switcher trigger and the switcher list always agree.
export function toSwitchableEmployers(
  employerUserMaps: EmployerUserMaps | undefined,
): SwitchableEmployer[] {
  return (employerUserMaps ?? [])
    .filter((map) => !!map.employer?.name)
    .map((map) => ({ id: map.employerId, name: map.employer?.name ?? '' }));
}
